export default __webpack_public_path__ + "static/media/DOM-MAY2025.7eb9b435.png";